import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

/**
 * Custom branded confirmation modal to replace browser's window.confirm()
 * Matches DIZEE's design language with #FF2300 accent color
 */
function ConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    title = "Confirm Action",
    message = "Are you sure you want to proceed?",
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    confirmStyle = "danger", // 'danger' or 'primary'
}) {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog
                as="div"
                className="relative"
                style={{ zIndex: 99999 }}
                onClose={onClose}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-[350px] mx-4 transform overflow-hidden rounded-2xl bg-black border-2 border-[#FF2300] p-6 text-left align-middle shadow-xl transition-all">
                                {/* Title */}
                                <Dialog.Title
                                    as="h3"
                                    className="text-white text-[18px] font-bold mb-6"
                                >
                                    {title}
                                </Dialog.Title>

                                {/* Message */}
                                <div className="mb-8">
                                    <p className="text-[rgba(255,255,255,0.5)] text-[12px] leading-[1.5]">
                                        {message}
                                    </p>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex space-x-4">
                                    <button
                                        type="button"
                                        className="flex-1 bg-transparent border-2 border-gray-600 text-white text-[13px] font-semibold py-3 px-4 rounded-lg hover:bg-gray-600/20 transition-colors focus:outline-none"
                                        onClick={onClose}
                                    >
                                        {cancelLabel}
                                    </button>
                                    
                                    <button
                                        type="button"
                                        className="flex-1 bg-[#FF2300] text-white text-[13px] font-semibold py-3 px-4 rounded-lg hover:bg-[#FF2300]/90 transition-colors focus:outline-none"
                                        onClick={handleConfirm}
                                    >
                                        {confirmLabel}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}

export default ConfirmModal;

